<template>
  <div>
    <button class="button button-white" @click="dialogUnlock=true">
      <b-icon icon="lock-open-outline" custom-size="mdi-18px"></b-icon>
      <span>{{ title }}</span>
    </button>
    <el-dialog
      :title="title"
      :visible.sync="dialogUnlock"
      width="300px"
      :lock-scroll="true"
      @open="openDialog"
      @close="closeDialog"
    >
      <div class="grid">
        <money v-model="amount" v-bind="money" class="u-16 el-input__inner text-center"></money>
      </div>
      <span slot="footer" class="grid start">
        <el-button @click="dialogUnlock = false">Отмена</el-button>
        <el-button type="primary" @click="Refund(amount)" :loading="loading">Подтвердить</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { apiUrl } from "@/api/apiUrl";
import errors from "@/localize/errors.js";
import { Money } from "v-money";

export default {
  name: "unlockDialog",
  props: ["transaction_id", "amountOrder", "currency"],
  data() {
    return {
      loading: false,
      title: "Разблокировать",
      dialogUnlock: false,
      amount: 0,
      showControls: false,
      money: {
        decimal: ".",
        thousands: " ",
        prefix: "",
        suffix: " " + this.currency,
        precision: 2,
        masked: false
      }
    };
  },
  methods: {
    Refund(amount) {
      var params = {
        transaction_id: this.transaction_id,
        amount: Math.round(this.amount * 100),
        operation: "unblock"
      };
      var config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      this.loading = true;
      axios
        .post(apiUrl + "transaction/operate", params, config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            this.$message({
              message: "Разблокирование успешно выполнено",
              type: "success"
            });
            setTimeout(() => {
              this.$emit("loadAsyncData");
            }, 500);
            this.dialogUnlock = false;
          } else {
            this.$message.error(
              "(" + data.state_id + ") " + errors[data.error_code]
            );
          }
          this.loading = false;
        })
        .catch(err => {
          this.$message.error(errors[err.response.data.error_code]);
          this.loading = false;
        });
    },
    openDialog() {
      this.amount = this.amountOrder / 100;
      document.documentElement.style.overflow = "hidden";
    },
    closeDialog() {
      this.amount = 0;
      document.documentElement.style.overflow = "auto";
    }
  },
  components: {
    Money
  }
};
</script>

<style>
</style>